import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { RestApiService } from '@/services'

import { ApplicationState } from '@/state/root.models'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import { jsonToQueryString } from '@/utils'

import { ResponsibleGamingTypeEnum } from '@/enums'
import { PlayerCardActionTypes } from '../constants'
import { PLAYER_CARD } from './api.routes'

import { PlayerCardModels } from '../'

const apiService: RestApiService = Container.get(RestApiService)

export const getRGExclusionThunk = createAsyncThunk(
  PlayerCardActionTypes.GET_RG_EXCLUSION,
  async (payload: PlayerCardModels.GetRGExclusionPayload, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoadingFullAction(true))

      const { auth } = thunkAPI.getState() as ApplicationState

      apiService.requestParams = {
        method: 'GET',
        endpoint: PLAYER_CARD.GET_RG_EXCLUSION,
        queries: jsonToQueryString({
          ...payload,
          brandId: auth.brand.siteId.toString(),
          //brandId: 'f1c808ad-dda5-4aa5-8553-63f99562ad05',
        }),
        isIncentiveAPI: true,
      }

      const response: PlayerCardModels.GetRGExclusionResponse =
        await apiService.getData(auth.brand.siteId.toString(), auth.token)

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
    }
  },
)

export const getRGExclusionExtraReducer = (
  builder: ActionReducerMapBuilder<PlayerCardModels.PlayerCardState>,
) => {
  builder.addCase(getRGExclusionThunk.pending, (state) => {
    state.isLoadingResponsibleGaming = true
  })
  builder.addCase(getRGExclusionThunk.fulfilled, (state, { payload, meta }) => {
    state.isLoadingResponsibleGaming = false

    const { data, ...pagination } = payload

    if (meta.arg.exclusionType === ResponsibleGamingTypeEnum.COOL_OFF) {
      state.responsibleGamingCoolOff = {
        ...state.responsibleGamingCoolOff,
        exlusionData: data,
        pagination: pagination,
      }
    } else {
      state.responsibleGamingExclusion = {
        ...state.responsibleGamingExclusion,
        exlusionData: data,
        pagination: pagination,
      }
    }
  })
}
